import { render, staticRenderFns } from "./product_template_multiple_select.vue?vue&type=template&id=27b1e3e8&"
import script from "./product_template_multiple_select.vue?vue&type=script&lang=js&"
export * from "./product_template_multiple_select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports